<frodo-page-shell [showConnectionIndicator]="showConnectionIndicator">
  <frodo-language-selector shell-header-action></frodo-language-selector>
  <p shell-header class="title">{{ titleKey | translate }}</p>

  <div class="cards-container">
    <frodo-card
      data-testid="home-start-button"
      [cardTitle]="cardTitleKey"
      [cardBackgroundColor]="cardBackgroundColor"
      [cardIcon]="cardIcon"
      [cardTitleColor]="cardTitleColor"
      (click)="onCardClick()"
    >
    </frodo-card>
  </div>
</frodo-page-shell>
